import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { MoralisService } from 'src/app/services/moralis.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm : any; 

  constructor(private formBuilder: FormBuilder,
    public router:Router,
    public authentificationService:AuthenticationService,
    public moralisService:MoralisService) { 
    this.loginForm = this.formBuilder.group({
      login: '',
      password: ''
    });
  }

 async onSubmit() {
    // Process checkout data here
    console.warn('Your fom has been submitted', this.loginForm.value);
    let login = this.loginForm.value["login"];
    let password = this.loginForm.value["password"];
    // Need to check access with moralis 
    try {
      let user = await this.moralisService.getMoralis().User.logIn(login,password);
      // user log in 
      this.authentificationService.isAuthenticated.next(true);
      this.router.navigateByUrl("/dashboard");
    }
    catch(error){
      console.log("error login");
    }

    // const user = new (this.moralisService.getMoralis()).User();
    // user.set("username", login);
    // user.set("password", password);
    // user.set("email", "csurbier@idevotion.fr");
    // try {
    //   await user.signUp();
    //   // Hooray! Let them use the app now.
    // } catch (error:any) {
    //   // Show the error message somewhere and let the user try again.
    //   console.log("Error: " + error.code + " " + error.message);
    // }
  }

  ngOnInit(): void {
  }

}
